import blog from '../blog'
import prognostic from '../prognostics'
import search from '../search'

const pagination = {
  elements: {
    container: document.querySelector('.pagination')
  },

  controls: {
    perPage: 12
  },

  handleClick: ({ items, categoryId, author, postType }) => {
    Array.from({ length: items.length }, (_, i) => {
      items[i].addEventListener('click', el => {
        el.preventDefault()
        const target = el.target
        const href = target.href
        
        if (href) {
          const url = new URL(href)
          const paginationValue = url.searchParams.get('pagina')
          
          if (paginationValue) {
            pagination.goToPage({ pageCurrent: paginationValue, categoryId, author, postType, target })
          }
        }
      })
    })
  },

  goToPage: ({ pageCurrent, categoryId, author, postType, target }) => {
    let elementSelect = target.closest(pagination.targetContainer).querySelector('.SelectPost')
    if (!elementSelect) {
      elementSelect = target.closest(pagination.targetContainer).querySelector('.SearchTitle')
    }
    if (!elementSelect) {
      elementSelect = target.closest(pagination.targetContainer).querySelector('.HeadSection-title')
    }
    if (elementSelect) {
      elementSelect.scrollIntoView({ block: 'center', behavior: 'smooth' })
    }
    if (postType === 'blog') {
      blog.init({ pageCurrent, id: categoryId, author, forceLoad: true })
    } else if (postType === 'prognostico') {
      prognostic.init({ pageCurrent, id: categoryId, forceLoad: true })
    } else {
      search.init({ pageCurrent, id: categoryId })
    }
  },

  calculateMaxPage: ({ totalPages, pageCurrent }) => {
    let maxLeft = pageCurrent - Math.floor(pagination.controls.perPage / 2)
    let maxRight = pageCurrent + Math.floor(pagination.controls.perPage / 2)

    if (maxLeft < 1) {
      maxLeft = 1
      maxRight = 5
    }

    if (maxRight > totalPages) {
      maxLeft = totalPages - 4
      maxRight = totalPages

      if (maxLeft < 1) {
        maxLeft = 1
      }
    }

    return {
      maxLeft,
      maxRight
    }
  },

  markup: ({ totalPages, pageCurrent }) => {
    const { maxLeft, maxRight } = pagination.calculateMaxPage({ totalPages, pageCurrent })
    let center = ''
    let left = ''
    let right = ''

    if (totalPages <= 1) {
      return ''
    }

    if (pageCurrent !== 1) {
      left = `
        <a class="prev page-numbers" href="${pagination.buildPageUrl(pageCurrent - 1)}" data-number=${pageCurrent - 1}><svg stroke="currentColor" fill="currentColor" strokewidth="0" viewBox="0 0 512 512" size="20" height="20" width="20" xmlns="http://www.w3.org/2000/svg"><path d="M217.9 256L345 129c9.4-9.4 9.4-24.6 0-33.9-9.4-9.4-24.6-9.3-34 0L167 239c-9.1 9.1-9.3 23.7-.7 33.1L310.9 417c4.7 4.7 10.9 7 17 7s12.3-2.3 17-7c9.4-9.4 9.4-24.6 0-33.9L217.9 256z"></path></svg></a>
        <a class="page-numbers" href="${pagination.buildPageUrl(1)}" data-number="1">1</a>
        <span class="page-numbers dots">…</span>
      `
    }

    if (pageCurrent !== totalPages) {
      right = `
        <span class="page-numbers dots">…</span>
        <a class="page-numbers" href="${pagination.buildPageUrl(totalPages)}" data-number="${totalPages}">${totalPages}</a>
        <a class="next page-numbers" href="${pagination.buildPageUrl(pageCurrent + 1)}" data-number="${pageCurrent + 1}"><svg stroke="currentColor" fill="currentColor" strokewidth="0" viewBox="0 0 512 512" size="20" height="20" width="20" xmlns="http://www.w3.org/2000/svg"><path d="M294.1 256L167 129c-9.4-9.4-9.4-24.6 0-33.9s24.6-9.3 34 0L345 239c9.1 9.1 9.3 23.7.7 33.1L201.1 417c-4.7 4.7-10.9 7-17 7s-12.3-2.3-17-7c-9.4-9.4-9.4-24.6 0-33.9l127-127.1z"></path></svg></a>
      `
    }

    for (let page = maxLeft; page <= maxRight; page++) {
      center += `
          ${pageCurrent == page 
            ? `<span aria-current="page" class="page-numbers current">${page}</span>`
            : `<a class="page-numbers" href="${pagination.buildPageUrl(page)}" data-number="${page}">${page}</a>`
          }`
    }

    const markupPagination = left + center + right

    return markupPagination
  },

  buildPageUrl: (page) => {
      const url = new URL(window.location.href);
      url.searchParams.set('pagina', page);
      return url.toString();
  },

  targetContainer: false,

  init: ({ totalPages, pageCurrent, categoryId, author, postType, wrapper, targetContainer = '.container', forceLoad = true }) => {
    pagination.elements.container = document.querySelector(wrapper + ' .pagination')
    pagination.targetContainer = targetContainer

    if (pagination.elements.container && forceLoad) {
      pagination.elements.container.innerHTML = ''
      pagination.elements.container.innerHTML = pagination.markup({ totalPages, pageCurrent, postType })
    }

    const items = document.querySelectorAll(wrapper + ' .pagination a')
    pagination.handleClick({ items, categoryId, author, postType })
  }
}

export default pagination
